/* eslint-disable no-undef */
import React, { useEffect, useRef, useState } from 'react';
import { Dashboard as DashboardLayout } from 'layouts';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid2,
  IconButton,
  Typography,
} from '@mui/material';
import styles from './styles';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles(styles);
import { useNavigate, useParams } from 'react-router';
import { showMeters } from 'js/actions/meterActions';
import { useDispatch, useSelector } from 'react-redux';
import {
  ComparativeCharges,
  LocationMaps,
  TopChart,
  UploadDocuments,
} from './components';
import Card from 'components/Card';
import {
  AttachMoney,
  Close,
  CompareArrows,
  Timeline,
  TrendingUpOutlined,
} from '@mui/icons-material';
import { BarChart, MostConsumeChart } from 'components';
import ComparativeChart from 'components/ComparativeYearConsumeChart';
import DayWithMostConsumeChart from 'components/DayWithMostConsumeChart';
import ChargeWithMostConsumeChart from 'views/Meter Dashboard/ChargeWithMostConsumeChart';
import RateVariation from 'views/Meter Dashboard/RateVariation';
import FPDailyAvrgChart from 'views/Meter Dashboard/FPDailyAvrgChart';
import FPGauge from 'views/Meter Dashboard/FPGauge';
import AmountByGroupChart from 'views/Meter Dashboard/AmountByGroupChart';
import { useIntl } from 'react-intl';
import theme from 'theme';
import {
  getChargeWithMostConsume,
  getComparativeYearConsume,
  getComparativeYearTariff,
  getDayWithMostConsume,
  getFpAvgPerMonth,
  getFPByMeter,
  getMonthWithMostConsume,
  getTotalsActualMonth,
} from 'js/actions/meterDashboardActions';

export default function Dashboard() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { corpId } = useParams();
  const { user } = useSelector((state) => state.user);
  const { meters } = useSelector((state) => state.meters);
  const [FPid, setFPid] = useState(null);
  const [FPdata, setFPdata] = useState([]);
  const mapContainer = useRef(null);
  const dashboardRef = useRef(null);
  const [selectedCorp, setSelectedCorp] = useState(null);
  const [meterSelected, setMeterSelected] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [openDocuments, setOpenDocuments] = useState(false);
  // const [meterFp, setMeterFp] = useState();
  const {
    totalsactualmonth,
    comparativeYearConsume,
    monthMostConsume,
    dayMostConsume,
    chargeMostConsume,
    comparativeYearTariff,
  } = useSelector((state) => state.meterDashboard);
  const navigate = useNavigate();
  const year = new Date().getFullYear();
  const currentMonth =
    new Date().getMonth() + 1 <= 9
      ? `0${new Date().getMonth() + 1}`
      : new Date().getMonth() + 1;
  const corporative = useSelector(
    user.adser == 1
      ? (state) => state.user.corporative
      : (state) => state.user.user.corporative
  );
  const [openComparative, setOpenComparative] = useState(false);

  useEffect(() => {
    dispatch(showMeters(corpId));
  }, [corpId]);

  useEffect(() => {
    let corpId = meterSelected?.corporative_id;
    let meterId = meterSelected?.id;
    if (corpId && meterId) {
      dispatch(getMonthWithMostConsume(corpId, meterId, year));
      dispatch(getComparativeYearConsume(corpId, meterId, year));
      dispatch(getDayWithMostConsume(corpId, meterId, year, currentMonth));
      dispatch(getChargeWithMostConsume(corpId, meterId));
      dispatch(getComparativeYearTariff(corpId, meterId, [year, year - 1]));
      dispatch(getTotalsActualMonth(meterId));
      dispatch(getFPByMeter(meterId, getData));
    }
  }, [meterSelected]);

  const getData = (data) => {
    if (data[0].id) {
      setFPid(data[0].id);
      dispatch(getFpAvgPerMonth(FPid, `${year}${currentMonth}`, getFPAvg));
    }
  };

  useEffect(() => {
    if (FPid) {
      dispatch(getFpAvgPerMonth(FPid, `${year}${currentMonth}`, getFPAvg));
    }
  }, [FPid]); // Se ejecuta cada vez que FPid cambie

  const getFPAvg = (data) => {
    setFPdata(data);
  };

  const totalMeter = meters
    ? meters.reduce((sum, consume) => {
        if (typeof consume.consumes.total === 'string') {
          return sum + parseFloat(consume.consumes.total.replace(/,/g, ''));
        } else {
          return sum + consume.consumes.total;
        }
      }, 0)
    : 0;

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  const consumeTotal = meters
    ? meters.reduce((sum, consume) => {
        if (typeof consume.consumes.total_kwh === 'string') {
          return sum + parseFloat(consume.consumes.total_kwh.replace(/,/g, ''));
        } else {
          return sum + consume.consumes.total_kwh;
        }
      }, 0)
    : 0;

  const formatt = (number) => {
    return `${number
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} kWh`;
  };

  const handleComparatives = () => {
    setOpenComparative(true);
  };

  const handleCorporativeView = () => {
    navigate(`/corporative/${corpId}`, { state: corporative });
  };

  return (
    <DashboardLayout title="Dashboard">
      <div className={classes.root}>
        <Grid2 container={true} spacing={4}>
          {/* Titulo */}
          <Grid2 size={12}>
            <Typography variant="h2" sx={{ color: '#A53693', ml: 2 }}>
              {corporative.name}
            </Typography>
          </Grid2>
          {/* Tarjetas */}
          <Grid2 size={{ lg: 3, sm: 6, xs: 12 }}>
            <Card
              bgColor="#A53693"
              footer={false}
              title="Consumo Acumulado al Día"
              data={formatt(consumeTotal)}
              icon={
                <TrendingUpOutlined
                  sx={{
                    color: '#A53693',
                    width: '2rem',
                    height: '2rem',
                    fontSize: '2rem',
                  }}
                />
              }
            />
          </Grid2>
          <Grid2 size={{ lg: 3, sm: 6, xs: 12 }}>
            <Card
              bgColor="#45B880"
              data={formatter.format(totalMeter)}
              title="Importe Estimado Acumulado al Día"
              footer="*No incluye IVA"
              icon={
                <AttachMoney
                  sx={{
                    color: '#45B880',
                    width: '2rem',
                    height: '2rem',
                    fontSize: '2rem',
                  }}
                />
              }
            />
          </Grid2>
          <Grid2 size={{ lg: 3, sm: 6, xs: 12 }}>
            <Card
              bgColor="#00AFEF"
              footer={false}
              data={true}
              clicked={true}
              action={handleComparatives}
              title="Comparativo de Mediciones"
              icon={
                <CompareArrows
                  sx={{
                    color: '#00AFEF',
                    width: '2rem',
                    height: '2rem',
                    fontSize: '2rem',
                  }}
                />
              }
            />
          </Grid2>
          <Grid2 size={{ lg: 3, sm: 6, xs: 12 }}>
            <Card
              bgColor="#EAAB36"
              clicked={true}
              action={handleCorporativeView}
              title="Nodos"
              footer={false}
              data={meters.length}
              icon={
                <Timeline
                  sx={{
                    color: '#EAAB36',
                    width: '2rem',
                    height: '2rem',
                    fontSize: '2rem',
                  }}
                />
              }
            />
          </Grid2>
          {/* Mapa de sucursales */}
          <Grid2 size={{ lg: 12, sm: 12, xs: 12 }}>
            <LocationMaps
              className={classes.item}
              corpId={corpId}
              dashboardRef={dashboardRef}
              mapContainer={mapContainer}
              setMeterSelected={setMeterSelected}
              setOpenDocuments={setOpenDocuments}
              setSelectedCorp={setSelectedCorp}
              setShowDetails={setShowDetails}
            />
          </Grid2>
          <Grid2 size={{ lg: 12, sm: 12, xs: 12 }}>
            <TopChart meters={meters} />
          </Grid2>
        </Grid2>
        {/* Detalles de medidor */}
        <Grid2 size={12} mt={2}>
          {meterSelected && (
            <Divider textAlign="left">
              <Typography
                sx={{ color: '#A53693', marginLeft: theme.spacing.unit * 2 }}
                variant="h2"
              >
                {meterSelected.name}
              </Typography>
            </Divider>
          )}
        </Grid2>
        {meterSelected && (
          <Grid2 container={true} spacing={2} pt={2}>
            <Grid2 size={{ lg: 9, md: 9, sm: 12, xs: 12 }} ref={dashboardRef}>
              <BarChart
                title={intl.formatMessage({
                  id: 'app.meter.board.demandAndConsump.title',
                })}
                custom={0}
                totalConsumeskW={totalsactualmonth[0]}
                totalConsumeskWh={totalsactualmonth[1]}
              />
            </Grid2>
            <Grid2 size={{ lg: 3, md: 3, sm: 12, xs: 12 }}>
              <MostConsumeChart
                title={intl.formatMessage({
                  id: 'app.meter.board.monthHighestConsum.title',
                })}
                year={year}
                monthMostConsume={monthMostConsume}
              />
            </Grid2>
            <Grid2 size={{ lg: 9, md: 9, sm: 12, xs: 12 }}>
              <ComparativeChart
                title={intl.formatMessage({
                  id: 'app.meter.board.consumDiference.title',
                })}
                year={year}
                dashboard={Dashboard.individual}
                comparativeYearConsume={comparativeYearConsume}
              />
            </Grid2>
            <Grid2 size={{ lg: 3, md: 3, sm: 12, xs: 12 }}>
              <Grid2 size={12} mb={2}>
                <DayWithMostConsumeChart
                  title={intl.formatMessage({
                    id: 'app.meter.board.groupHighestConsumMonth.title',
                  })}
                  groupName={dayMostConsume.group_name}
                  consume={dayMostConsume.consume}
                  co2={dayMostConsume.co2}
                  day={false}
                />
              </Grid2>
              <Grid2 size={12}>
                <ChargeWithMostConsumeChart
                  chargeMostConsume={chargeMostConsume}
                />
              </Grid2>
            </Grid2>
            <Grid2 size={12}>
              <RateVariation
                title={intl.formatMessage({
                  id: 'app.meter.board.ratesVariation.title',
                })}
                data={comparativeYearTariff}
                year={year}
                lastYear={year - 1}
              />
            </Grid2>
            <Grid2 size={{ lg: 9, md: 9, sm: 12, xs: 12 }}>
              <FPDailyAvrgChart
                title={intl.formatMessage({
                  id: 'app.meter.board.fpVariationInMonth.title',
                })}
                data={FPdata}
              />
            </Grid2>
            <Grid2 size={{ lg: 3, md: 3, sm: 12, xs: 12 }}>
              <FPGauge meterId={meterSelected.id} meterFp={FPid} />
            </Grid2>
            <Grid2 size={12}>
              <AmountByGroupChart
                corpId={meterSelected.corporative_id}
                meterId={meterSelected.id}
                titleAmount={intl.formatMessage({
                  id: 'app.meter.board.amountByGroup.title',
                })}
                titleConsumption={intl.formatMessage({
                  id: 'app.meter.board.consumptionByGroup.title',
                })}
              />
            </Grid2>
          </Grid2>
        )}
        <ComparativeCharges
          open={openComparative}
          setOpen={setOpenComparative}
          meter={meters}
        />
      </div>
      <Dialog
        aria-labelledby="customized-dialog-title"
        fullWidth
        maxWidth={'sm'}
        onClose={() => {
          setShowDetails(false);
        }}
        open={showDetails}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => {
            setShowDetails(false);
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box>
              <Typography variant="h6">
                {selectedCorp ? selectedCorp.name : ''}
              </Typography>
            </Box>
            <IconButton
              aria-label="close"
              onClick={() => {
                setShowDetails(false);
              }}
              size="small"
            >
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers style={{ marginBottom: '3rem' }}>
          {selectedCorp ? (
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                alignItems: 'center',
              }}
            >
              <Typography
                style={{ fontWeight: 400, textAlign: 'center' }}
                variant="h6"
              >
                <Typography style={{ fontWeight: 500 }}>
                  {intl.formatMessage({
                    id: 'app.metersCards.editMeter.descriptLbl',
                  })}
                </Typography>
                {selectedCorp.description}
              </Typography>
              <Typography
                style={{ fontWeight: 400, textAlign: 'center' }}
                variant="h6"
              >
                <Typography style={{ fontWeight: 500 }}>
                  {intl.formatMessage({
                    id: 'app.metersCards.editMeter.countryLbl',
                  })}
                </Typography>
                {selectedCorp.country}
              </Typography>
              <Typography
                style={{ fontWeight: 400, textAlign: 'center' }}
                variant="h6"
              >
                <Typography style={{ fontWeight: 500 }}>
                  {intl.formatMessage({
                    id: 'app.metersCards.editMeter.stateLbl',
                  })}
                </Typography>
                {selectedCorp.state}
              </Typography>
              <Typography
                style={{ fontWeight: 400, textAlign: 'center' }}
                variant="h6"
              >
                <Typography style={{ fontWeight: 500 }}>
                  {intl.formatMessage({
                    id: 'app.metersCards.editMeter.cityLbl',
                  })}
                </Typography>
                {selectedCorp.city}
              </Typography>
              <Typography
                style={{ fontWeight: 400, textAlign: 'center' }}
                variant="h6"
              >
                <Typography style={{ fontWeight: 500 }}>
                  {intl.formatMessage({
                    id: 'app.metersCards.editMeter.postalCodeLbl',
                  })}
                </Typography>
                {selectedCorp.cp}
              </Typography>
              <Typography
                style={{ fontWeight: 400, textAlign: 'center' }}
                variant="h6"
              >
                <Typography style={{ fontWeight: 500 }}>
                  {intl.formatMessage({
                    id: 'app.metersCards.editMeter.neighborhoodLbl',
                  })}
                </Typography>
                {selectedCorp.county}
              </Typography>
              <Typography
                style={{ fontWeight: 400, textAlign: 'center' }}
                variant="h6"
              >
                <Typography style={{ fontWeight: 500 }}>
                  {intl.formatMessage({
                    id: 'app.metersCards.editMeter.addressLbl',
                  })}
                </Typography>
                {selectedCorp.address}
              </Typography>
              {selectedCorp.contracted_demand && (
                <Typography
                  style={{ fontWeight: 400, textAlign: 'center' }}
                  variant="h6"
                >
                  <Typography style={{ fontWeight: 500 }}>
                    {intl.formatMessage({
                      id: 'app.metersCards.editMeter.contractedDemandLbl',
                    })}
                  </Typography>
                  {selectedCorp.contracted_demand} kW
                </Typography>
              )}
            </Box>
          ) : (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '50vh',
              }}
            >
              <CircularProgress />
            </div>
          )}
        </DialogContent>
      </Dialog>
      <UploadDocuments
        corporative={corpId}
        open={openDocuments}
        selectedCorp={selectedCorp}
        setOpen={setOpenDocuments}
      />
    </DashboardLayout>
  );
}
